import App from '../index.js';

App.GlobalSetting = (function () {
    function updateBlacklistFile ( e ) {
        let elBlacklistFileDisplay = $('#blacklist_file_display');
        if (e.target.files[0]) {
            elBlacklistFileDisplay.html(`<div class="blacklist-file-item">
                <div class="blacklist-file-name">
                    <span>${ e.target.files[0]?.name }</span>
                </div>
                <div class="blacklist-file-action">
                    <a href="#" class="blacklist-file-remove"><i class="fa fa-trash"></i></a>
                </div>
            </div>`);
        } else {
            elBlacklistFileDisplay.html('');
        }

        $('#blacklist_file_field_label').html(elBlacklistFileDisplay.find('> *').length > 0 ? 'Replace Text File' : 'Upload Text File');
    }



    function buildWysiwygEditor () {
        App.wysiwygEditor('.mce-editor', 300, null, null, 'numlist bullist');
    }

    function removeBlacklistFile ( e ) {
        e.preventDefault();
        $('[name="blacklist_file_field"]').val('');
        $(this).closest('.blacklist-file-item').remove();
        $('#blacklist_file_field_label').html('Upload Text File');
    }

    return {
        init: function () {
            $('body')
                .on('change', '#blacklist_file_field', updateBlacklistFile)
                .on('click', '#blacklist_file_holder .blacklist-file-remove', removeBlacklistFile);

            buildWysiwygEditor();
        }
    };
})();


App.registerRoute('global-bots.global-settings', App.GlobalSetting.init);
App.registerRoute('global-bots.setting', App.GlobalSetting.init);

export default App.GlobalSetting;
